import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "valueBar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, "time: " + _toDisplayString(_ctx.convertTime(_ctx.time)) + " | value: " + _toDisplayString(_ctx.value), 1),
    _hoisted_2
  ]))
}